enum Role {
    Host = 'Host',
    Admin = 'Admin',
    Assistencia = 'Assistencia',
    Administrador = 'Administrador',
    Medico = 'Medico',
    Secretario = 'Secretario',
    Enfermeiro = 'Enfermeiro',
    TecEnfermagem = 'TecEnfermagem',
    AdminMedico = 'Admin_Medico',
}

export default Role;
